import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Button from "../../../components/Button";
import PageTitle from "../../../components/PageTitle";
import Layout from "../../../components/Layout";
// import classes from "../report.module.css";
import Badge from "../../../components/Badge";
import Modal from "../../../components/Modal";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { Grid, Tabs, Tab, Box } from "@mui/material";
import Select from "react-select";
import { Icon } from "@iconify/react/dist/iconify.js";
import useStyles from "../styles";
import nosearch from "../../../assets/images/no-search.svg";
import NotFounditem from "../../error/NotFound";
import PageLoader from "../../../components/PageLoader";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import Switch from "@mui/material/Switch";
import useWindowSize from "../../../hooks/useWindow";

// const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const CLASSES_ENDPOINT = "/api/v1/class";
const PROMOTION_ENDPOINT = "/api/v1/promotion/settings";
const GET_CLASS_GRADES = "/api/v1/promotion/eligible-students";

const Promotion = () => {
  const [activeSession, setActiveSession] = useState(null);
  const [selectedSession, setSelectedSession] = useState("");
  const [allSessions, setAllSessions] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [mode, setMode] = useState("automatic");
  const classes = useStyles();
  const [classesData, setClassData] = useState([]);
  const [passMark, setPassMark] = useState("");
  const [classPromotions, setClassPromotions] = useState([{ from: [], to: [] }]);
  const [isOrgLoading, setIsOrgLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [allowManualOverride, setAllowManualOverride] = useState(false);
  const [autoAssignClass, setAutoAssignClass] = useState(false);
  const [promotionSettings, setPromotionSettings] = useState({
    allow_manual_override: false,
    auto_assign_class: true
  });

  // eslint-disable-next-line no-console
  console.log("classPromotions", classPromotions);

  // States for promotion table
  const [selectedTab, setSelectedTab] = useState("promotion");
  const [promotionData, setPromotionData] = useState([]);
  const [isLoadingPromotion, setIsLoadingPromotion] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [toClass, setToClass] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [isPromoting, setIsPromoting] = useState(false);

  const width = useWindowSize();
  const mobile = width < 600;

  // eslint-disable-next-line no-console
  console.log("filteredData", filteredData);

  const Toggle = Switch;

  const columns = [
    {
      name: "Student Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Student Name</p>}
          { `${row?.first_name}  ${row?.last_name}` || "--/--" }
        </>
      )
    },
    {
      name: "Session Average",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Session Average</p>}
          {row?.average_score || "--/--"}
        </>
      )
    },
    {
      name: "Session Grade",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Session Grade</p>}
          {row?.grades || "--/--"}
        </>
      )
    },
    {
      name: "Status",
      center: "true",
      cell: (row) => (
        <p style={{ display: "flex", flexDirection: "column" }}>
          {mobile && <p style={{ margin: 0, fontSize: "12px" }}>Status</p>}
          <Badge status={row?.promotion_status} />
        </p>
      )
    }
  ];

  const getAllClasses = () => {
    httprequest
      .get(CLASSES_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setClassData(physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  // const getAllTerms = (sessionId) => {
  //   httprequest
  //     .get(TERM_ENDPOINT)
  //     .then((res) => {
  //       setSelectedSessionTerms(res?.data?.data.filter((term) => term?.session_id === sessionId));
  //     });
  // };

  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      const activeSesh = res?.data?.data?.find((session) => session?.current_session === true);
      setActiveSession(activeSesh);
      setSelectedSession(activeSesh?.id || "");
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  const getPromotionData = async () => {
    // if (!selectedClass) {
    //   toast.error("Please select a class first");

    //   return;
    // }

    if (!selectedSession && !activeSession?.id) {
      toast.error("Please select a session first");

      return;
    }

    setIsLoadingPromotion(true);
    try {
      const sessionId = selectedSession || activeSession?.id;
      const url = `${GET_CLASS_GRADES}?session_id=${sessionId}&class_id=${selectedClass}`;

      const res = await httprequest.get(url);
      const data = res?.data?.data || res?.data || [];

      setFilteredData(data?.students || []);
      const students = data?.students || [];
      setPromotionData(students);

      // let filteredStudents = students;
      // if (mode === "automatic") {
      //   filteredStudents = students.filter(student => student?.promotion_status === "eligible"
      //   );
      // }
      // setFilteredData(filteredStudents);
      setSelectedRows([]);
    } catch (err) {
      toast.error(err?.response?.data?.message);
      setPromotionData([]);
      setSelectedRows([]);
      setFilteredData([]);
    } finally {
      setIsLoadingPromotion(false);
    }
  };

  const handleSessionChange = (e) => {
    const sessionId = e.target.value;
    setSelectedSession(sessionId);

    if (selectedTab === "promotion" && selectedClass) {
      getPromotionData();
    }
  };

  const handleClassChange = (e) => {
    setSelectedClass(e.target.value);

    if (selectedTab === "promotion" && (selectedSession || activeSession?.id)) {
      getPromotionData();
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);

    if (newValue === "promotion" && selectedClass && (selectedSession || activeSession?.id)) {
      getPromotionData();
    }
  };

  const handleSearch = (query) => {
    if (!query.trim()) {
      setFilteredData(promotionData);

      return;
    }

    const filtered = promotionData.filter(item => (item.student_name?.toLowerCase().includes(query.toLowerCase()) ||
       item?.name?.toLowerCase()?.includes(query.toLowerCase()) ||
       item?.student_id?.toLowerCase()?.includes(query.toLowerCase()) ||
       item?.admission_number?.toLowerCase()?.includes(query.toLowerCase()) ||
       item?.grade?.toLowerCase()?.includes(query.toLowerCase()))
    );
    setFilteredData(filtered);
  };

  // Handle window resize for mobile detection
  // useEffect(() => {
  //   const handleResize = () => {
  //     setMobile(window.innerWidth <= 768);
  //   };

  //   window.addEventListener("resize", handleResize);

  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // When filters change and promotion tab is active, fetch data
  useEffect(() => {
    if (selectedTab === "promotion" && selectedClass && (selectedSession || activeSession?.id)) {
      getPromotionData();
    }
  }, [selectedClass, selectedSession, selectedTab, activeSession]);

  // Toggle use default pass mark for a specific class
  const toggleUseDefaultPassMark = (index) => {
    const updatedPromotions = [...classPromotions];
    updatedPromotions[index].use_default_pass_mark = !updatedPromotions[index].use_default_pass_mark;

    // If enabling default pass mark, reset the custom pass mark
    if (updatedPromotions[index].use_default_pass_mark) {
      updatedPromotions[index].pass_mark = promotionSettings.pass_mark;
    } else {
      updatedPromotions[index].pass_mark = promotionSettings.pass_mark;
    }

    setClassPromotions(updatedPromotions);
  };

  // Update pass mark for a specific class
  const updateClassPassMark = (index, value) => {
    const updatedPromotions = [...classPromotions];

    if (value === "") {
      updatedPromotions[index].pass_mark = "";
    } else {
      const numValue = parseInt(value) || 0;

      // Validate range
      if (numValue < 0) {
        updatedPromotions[index].pass_mark = 0;
      } else if (numValue > 100) {
        updatedPromotions[index].pass_mark = 100;
      } else {
        updatedPromotions[index].pass_mark = numValue;
      }
    }

    setClassPromotions(updatedPromotions);
  };

  // Update global pass mark only
  const handleUpdateGlobalPassMark = async () => {
    if (!promotionSettings.pass_mark) {
      toast.error("Please enter a valid pass mark");

      return;
    }

    try {
      setIsSaving(true);

      // Update global pass mark only
      await httprequest.patch(`${PROMOTION_ENDPOINT}`, {
        pass_mark: promotionSettings?.pass_mark,
        promotion_mode: promotionSettings?.allow_manual_override ? "manual" : "automatic",
        session_id: selectedSession || activeSession?.id
      });

      toast.success("Global pass mark updated successfully!");

      // Update class promotions that use default pass mark
      const updatedPromotions = classPromotions.map(promo => {
        if (promo.use_default_pass_mark) {
          return { ...promo, pass_mark: promotionSettings.pass_mark };
        }

        return promo;
      });

      setClassPromotions(updatedPromotions);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setIsSaving(false);
    }
  };

  // Save all promotion settings together
  const handleSaveAllPromotionSettings = async () => {
  // Validate all settings
    if (!promotionSettings.pass_mark) {
      toast.error("Please enter a valid global pass mark");

      return;
    }

    const invalidPromotions = classPromotions.filter(
      promo => !promo.from?.[0]?.value || !promo.to?.[0]?.value
    );

    if (invalidPromotions.length > 0) {
      toast.error("Please complete all class mappings before saving");

      return;
    }

    const payload = {
      pass_mark: promotionSettings.pass_mark,
      session_id: selectedSession || activeSession?.id,
      promotion_mode: "automatic",
      allow_manual_override: promotionSettings.allow_manual_override,
      auto_assign_class: promotionSettings.auto_assign_class,
      class_mappings: classPromotions.map(promo => ({
        from_class: promo.from[0]?.value,
        to_class: promo.to[0]?.value,
        pass_mark: promo.use_default_pass_mark ? promotionSettings.pass_mark : promo.pass_mark,
        use_default_pass_mark: promo.use_default_pass_mark
      }))
    };

    try {
      setIsSaving(true);
      await httprequest.patch(PROMOTION_ENDPOINT, payload);
      toast.success("All promotion settings saved successfully!");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save promotion settings");
    } finally {
      setIsSaving(false);
    }
  };
  const handleModalOpen = () => {
    setModalOpen(!modalOpen);
  };

  // Handle adding a new class promotion
  const handleAddClassPromotion = () => {
    const newPromotion = {
      from: [],
      to: [],
      pass_mark: promotionSettings.pass_mark,
      use_default_pass_mark: true
    };
    setClassPromotions([...classPromotions, newPromotion]);
  };

  const handleDeleteClassPromotion = (index) => {
    if (classPromotions.length > 1) {
      setClassPromotions(classPromotions.filter((_, i) => i !== index));
    }
  };

  const handleClassPromotionChange = (index, field, value) => {
    const updated = [...classPromotions];
    updated[index][field] = value;
    setClassPromotions(updated);
  };

  const getPromotionSettings = async () => {
    setIsOrgLoading(true);
    try {
      const res = await httprequest.get(PROMOTION_ENDPOINT);
      const settings = res?.data?.data;
      const mappings = settings?.class_mappings || [];

      if (settings?.pass_mark) {
        setPassMark(settings.pass_mark.toString());
        setPromotionSettings((prev) => ({
          ...prev,
          pass_mark: settings.pass_mark
        }));
      }

      if (mappings?.length > 0) {
        const transformed = mappings.map(m => ({
          from: [{ value: m.from_class.id, label: m.from_class.name }],
          to: [{ value: m.to_class.id, label: m.to_class.name }],
          pass_mark: m.use_default_pass_mark ? settings.pass_mark : m.pass_mark,
          use_default_pass_mark: m.use_default_pass_mark ?? true
        }));
        setClassPromotions(transformed);
      }
    } catch (err) {
      toast.error(err?.response?.data || "Failed to fetch promotion settings");
    } finally {
      setIsOrgLoading(false);
    }
  };

  const handleSavePromotions = async () => {
    if (!passMark) {
      toast.error("Please enter a pass mark");

      return;
    }

    if (
      classPromotions?.some(
        (promo) => promo?.from?.length === 0 || promo?.to?.length === 0
      )
    ) {
      toast.error("Each promotion mapping must have at least one 'from' and 'to' class");

      return;
    }

    const payload = {
      session_id: selectedSession || activeSession?.id,
      pass_mark: Number(passMark),
      allow_manual_override: allowManualOverride,
      auto_assign_class: autoAssignClass,
      promotion_mode: "automatic",
      class_mappings: classPromotions.flatMap((promo) => promo?.from?.map((fromClass) => ({
        from_class: fromClass.value,
        to_class: promo.to[0]?.value,
        use_default_pass_mark: true
      }))
      )
    };

    try {
      setIsSaving(true);
      await httprequest.patch(PROMOTION_ENDPOINT, payload);
      toast.success("Promotion settings saved successfully!");
      setModalOpen(false);
      getPromotionSettings();

      // Refresh promotion data if tab is active
      if (selectedTab === "promotion") {
        getPromotionData();
      }
    } catch (err) {
      toast.error(err?.response?.data || "Failed to save promotion settings");
    } finally {
      setIsSaving(false);
    }
  };

  const handleRowSelected = (selected) => {
    setSelectedRows(selected.selectedRows);
  };

  const handleModeChange = (newMode) => {
    setMode(newMode);
    setSelectedRows([]);
  };

  const handleToClassChange = (e) => {
    setToClass(e.target.value);
  };

  // Promote students
  const handlePromoteStudents = async () => {
    if (!selectedSession && !activeSession?.id) {
      toast.error("Please select a session");

      return;
    }

    if (mode === "manual" && !toClass) {
      toast.error("Please select a 'To' class for manual promotion");

      return;
    }

    if (mode === "manual" && selectedRows.length === 0) {
      toast.error("Please select at least one student for manual promotion");

      return;
    }

    setIsPromoting(true);
    try {
      const sessionId = selectedSession || activeSession?.id;
      let payload = {};

      if (mode === "automatic") {
        payload = {
          mode: "automatic",
          session_id: sessionId
        };
      } else {
        payload = {
          mode: "manual",
          student_ids: selectedRows.map(row => row.student_id),
          to_class_id: toClass,
          session_id: sessionId,
          promotion_status: "promoted"
        };
      }

      const res = await httprequest.post("/api/v1/promotion/students", payload);

      if (res.status === 200 || res.status === 201) {
        toast.success("Students promoted successfully!");

        // Refresh data
        getPromotionData();
        setSelectedRows([]);

        if (mode === "automatic") {
          setMode("manual");
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to promote students");
    } finally {
      setIsPromoting(false);
    }
  };

  useEffect(() => {
    getAllSessions();
    getPromotionSettings();
    getAllClasses();
  }, []);

  // Load terms when active session is set
  // useEffect(() => {
  //   if (activeSession?.id) {
  //     getAllTerms(activeSession.id);
  //   }
  // }, [activeSession]);

  return (
    <Layout>
      <div className="page-content">
        <PageTitle
          title="Promotion"
          subtitle="Manage students promotions."
          button={
            <Button
              variant="primary"
              buttonSize="fluid"
              color="btndefault"
              buttonName="Promotion Settings"
              onClick={handleModalOpen}
            />
          }
        />

        {/* Filters Section */}
        <div className="flex gap-10 flex-wrap">
          <div>
            {allSessions.length > 0 && (
              <SelectGroup
                label="Session"
                children={
                  <select
                    value={selectedSession}
                    onChange={handleSessionChange}
                    name="session"
                  >
                    <option value="">---Select Session---</option>
                    {allSessions?.map((sesh) => {
                      return (
                        <option key={sesh?.id} value={sesh?.id}>
                          {sesh?.session}
                          {sesh?.current_session ? " (Current)" : ""}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>

        </div>

        <div className="margin-top-30">
          <div className="chart_div">
            {isOrgLoading ? (
              <PageLoader />
            ) : (
              <Box>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="promotion tabs"
                >
                  <Tab
                    key="promotion"
                    value="promotion"
                    label="Student Promotion"
                    sx={{ textTransform: "none" }}
                  />
                  <Tab
                    key="settings"
                    value="settings"
                    label="Promotion Settings"
                    sx={{ textTransform: "none" }}
                  />
                </Tabs>

                {/* Tab Content */}
                <Box sx={{ p: 2 }}>
                  {selectedTab === "promotion" && (
                    <div>
                      <div className={classes.promotionheader}>
                        <Grid container spacing={2} className="input-padding">
                          <Grid item lg={3} md={3} sm={3} xs={12}>
                            <div className={classes.modeContainer}>
                              <h6 className={classes.modeLabel}>From</h6>
                              <SelectGroup
                                label=""
                                children={
                                  <select
                                    value={selectedClass}
                                    onChange={handleClassChange}
                                    name="class"
                                  >
                                    <option value="">---Select Class---</option>
                                    {classesData?.map((cls) => {
                                      return (
                                        <option key={cls?.id} value={cls?.id}>
                                          {cls?.class_name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                }
                              />
                            </div>
                          </Grid>
                          <Grid item lg={3} md={3} sm={3} xs={12}>
                            <div className={classes.modeContainer}>
                              <h6 className={classes.modeLabel}>To</h6>
                              <SelectGroup
                                label=""
                                children={
                                  <select
                                    value={toClass}
                                    onChange={handleToClassChange}
                                    name="toClass"
                                  >
                                    <option value="">---Select Class---</option>
                                    {classesData?.map((cls) => {
                                      return (
                                        <option key={cls?.id} value={cls?.id}>
                                          {cls?.class_name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                }
                              />
                            </div>
                          </Grid>
                          <Grid item lg={2} md={2} sm={2} xs={12}>
                            <div className={classes.modeContainers}>
                              <h6 className={classes.modeLabel}>Mode</h6>

                              <div className={classes.modeOptions}>
                                <label className={classes.modeOption}>
                                  <input
                                    type="radio"
                                    name="mode"
                                    value="automatic"
                                    checked={mode === "automatic"}
                                    onChange={(e) => handleModeChange(e.target.value)}
                                  />
                                  <span>Automatic</span>
                                </label>

                                <label className={classes.modeOption}>
                                  <input
                                    type="radio"
                                    name="mode"
                                    value="manual"
                                    checked={mode === "manual"}
                                    onChange={(e) => setMode(e.target.value)}
                                  />
                                  <span>Manual</span>
                                </label>
                              </div>
                            </div>
                          </Grid>

                        </Grid>
                      </div>

                      {isLoadingPromotion ? (
                        <PageLoader />
                      ) : filteredData.length > 0 ? (
                        <>
                          <Table
                            data={filteredData}
                            columns={columns}
                            subHeader={true}
                            pagination
                            paginationPerPage={10}
                            handleRowSelected={handleRowSelected}
                            selectableRows={mode === "manual"}
                            subHeaderComponent={
                              <TableSearch
                                placeholder="Search students by name..."
                                searchTableFunc={handleSearch}
                              />
                            }
                          />
                          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                            <Button
                              variant="primary"
                              buttonSize="large"
                              color="btndefault"
                              buttonName={
                                mode === "automatic"
                                  ? "Promote Eligible Students Automatically"
                                  : `Promote Selected Students (${selectedRows.length})`
                              }
                              onClick={handlePromoteStudents}
                              isLoading={isPromoting}
                              disabled={
                                mode === "automatic"
                                  ? false
                                  : selectedRows.length === 0 || !toClass
                              }
                            />
                          </div>
                        </>
                      ) : (
                        <div className={classes.notfound}>
                          <NotFounditem
                            img={nosearch}
                            title="No Promotion Data Found"
                            subtitle={
                              !selectedClass ?
                                "Please select a class to view promotion data." :
                                !selectedSession && !activeSession?.id ?
                                  "Please select a session to view promotion data." :
                                  "No student data found for the selected class and session."
                            }
                          />
                        </div>
                      )}
                    </div>
                  )}

                  {selectedTab === "settings" && (
                    <div className={`page-content ${classes.wrapper}`}>
                      {/* Global Settings */}
                      <div className={classes.headerItems}>
                        <Grid container spacing={2} className="input-padding">
                          <Grid item lg={4} md={4} sm={6} xs={12}>
                            <div className={classes.globalCard}>
                              <h4>Default Pass Mark</h4>
                              <p className="text-muted">
              This is the standard pass percentage for promotion. Individual
              classes can override this if needed.
                              </p>
                              <div className={classes.passmarkInputGroup}>
                                <input
                                  type="number"
                                  defaultValue={passMark}
                                  onChange={(e) => setPromotionSettings({
                                    ...promotionSettings,
                                    pass_mark: parseInt(e.target.value) || 0
                                  })}
                                  min="0"
                                  max="100"
                                />
                                <Button
                                  variant="primary"
                                  buttonSize="fluid"
                                  buttonName="Update"
                                  color="btndefault"
                                  onClick={handleUpdateGlobalPassMark}
                                />
                              </div>
                            </div>
                          </Grid>

                          <Grid item lg={4} md={4} sm={6} xs={12}>
                            <div className={classes.globalCard}>
                              <div className={classes.toggleHeader}>
                                <h4>Allow Manual Override</h4>
                                <Toggle
                                  checked={promotionSettings?.allow_manual_override}
                                  onChange={(e) => setPromotionSettings({
                                    ...promotionSettings,
                                    allow_manual_override: e.target.checked
                                  })}
                                />
                              </div>
                              <p className="text-muted">
              Let administrators promote students who do not meet the automatic
              pass criteria
                              </p>
                            </div>
                          </Grid>

                          <Grid item lg={4} md={4} sm={6} xs={12}>
                            <div className={classes.globalCard}>
                              <div className={classes.toggleHeader}>
                                <h4>Auto-Assign Class</h4>
                                <Toggle
                                  checked={promotionSettings.auto_assign_class}
                                  onChange={(e) => setPromotionSettings({
                                    ...promotionSettings,
                                    auto_assign_class: e.target.checked
                                  })}
                                />
                              </div>
                              <p className="text-muted">
              Automatically link each class to its next class in the school
              hierarchy, reducing manual setup.
                              </p>
                            </div>
                          </Grid>
                        </Grid>
                      </div>

                      {/* Class Promotion Grid */}
                      <Grid container spacing={2} className="input-padding">
                        {classPromotions.map((promo, index) => (
                          <Grid item lg={3} md={3} sm={6} xs={12} key={index}>
                            <div className={classes.classCard}>
                              <div className={classes.row}>
                                <span className={classes.label}>Class:</span>
                                <span className={classes.value}>
                                  {promo.from?.[0]?.label || "Not selected"}
                                </span>
                              </div>

                              <div className={classes.row}>
                                <span className={classes.label}>Promotes to:</span>
                                <span className={classes.value}>
                                  {promo.to?.[0]?.label || "Not selected"}
                                </span>
                              </div>

                              <div className={classes.checkboxRow}>
                                <input
                                  type="checkbox"
                                  checked={promo?.use_default_pass_mark}
                                  onChange={() => toggleUseDefaultPassMark(index)}
                                />
                                <span>Use default pass mark</span>
                              </div>

                              {promo.use_default_pass_mark && (
                                <div className={classes.passmark}>
                                  <span>Set minimum pass mark</span>
                                  <input
                                    type="number"
                                    // eslint-disable-next-line no-undefined
                                    value={promo.pass_mark !== null && promo.pass_mark !== undefined ? promo.pass_mark : ""}
                                    disabled={promo.use_default_pass_mark}
                                    onChange={(e) => updateClassPassMark(index, e.target.value)}
                                    onBlur={(e) => {
                                      // When field loses focus, ensure it has a valid value
                                      if (e.target.value === "" || isNaN(e.target.value)) {
                                        updateClassPassMark(index, promotionSettings.pass_mark || "0");
                                      }
                                    }}
                                    min="0"
                                    max="100"
                                    placeholder={promo.use_default_pass_mark ? "Using default" : "0-100"}
                                  />
                                </div>
                              )}
                            </div>
                          </Grid>
                        ))}
                      </Grid>

                      {/* Save All Settings Button */}
                      <div className={classes.saveAllSection}>
                        <Button
                          variant="primary"
                          buttonSize="large"
                          buttonName="Update Settings"
                          color="btndefault"
                          onClick={handleSaveAllPromotionSettings}
                          isLoading={isSaving}
                        />
                      </div>
                    </div>
                  )}
                </Box>
              </Box>
            )}
          </div>
        </div>

        <Modal
          title="Promotion Settings"
          subtitle="Set promotion criterias."
          modalContent={
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Promotional Pass Mark (%)"
                  margin="normal"
                  required
                  placeHolder="E.g 80%"
                  inputType="number"
                  min="0"
                  max="100"
                  value={passMark}
                  onChange={(e) => setPassMark(e.target.value)}
                />
                <p className="text-muted small delete-icon">Students scoring below this mark will be required to repeat the class.</p>
              </Grid>

              {/* <Grid item lg={12} md={12} sm={12} xs={12} className={classes.label}>
                Class Promotions
                <p className="text-muted small">Define which classes students get promoted to.</p>
              </Grid> */}

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <div className={classes.toggleHeader}>
                  <h4>Allow Manual Override</h4>
                  <Toggle
                    checked={allowManualOverride}
                    onChange={(e) => setAllowManualOverride(e.target.checked)}
                  />
                </div>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <div className={classes.globalCard}>
                  <div className={classes.toggleHeader}>
                    <h4>Auto-Assign Class</h4>
                    <Toggle
                      checked={autoAssignClass}
                      onChange={(e) => setAutoAssignClass(e.target.checked)}
                    />
                  </div>
                </div>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                {classPromotions.map((promotion, index) => (
                  <Grid key={index} container className={`${classes.border} align-items-center`} spacing={2}>
                    <Grid item xs={5}>
                      <div className="multiple-select">
                        <p>
                          From Class
                          <span className="input-required"> * </span>
                        </p>
                        <Select
                          name="from_class"
                          required
                          closeMenuOnSelect={false}
                          value={promotion.from}
                          onChange={(val) => handleClassPromotionChange(index, "from", val ? [val] : [])}
                          menuPortalTarget={document.body}
                          options={classesData.map(c => ({ value: c.id, label: c.class_name }))}
                          styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 })
                          }}
                          isClearable
                          isSearchable
                          placeholder="Select source class..."
                        />
                      </div>
                    </Grid>

                    <Grid item xs={1} className="text-center">
                      <Icon icon="mdi:arrow-right" width="24" height="24" style={{ marginTop: "20px" }} />
                    </Grid>

                    <Grid item xs={5}>
                      <div className="multiple-select">
                        <p>
                          To Class
                          <span className="input-required"> * </span>
                        </p>
                        <Select
                          name="to_class"
                          required
                          closeMenuOnSelect={false}
                          menuPortalTarget={document.body}
                          value={promotion.to}
                          onChange={(val) => handleClassPromotionChange(index, "to", val ? [val] : [])}
                          options={classesData.map(c => ({ value: c.id, label: c.class_name }))}
                          styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 })
                          }}
                          isClearable
                          isSearchable
                          placeholder="Select target class..."
                        />
                      </div>
                    </Grid>

                    <Grid item xs={1}>
                      {classPromotions.length > 1 && (
                        <div
                          onClick={() => handleDeleteClassPromotion(index)}
                          className="delete-icon"
                          title="Remove this mapping"
                        >
                          <Icon icon="mingcute:delete-2-line" width="24" height="24" />
                        </div>
                      )}
                    </Grid>
                  </Grid>
                ))}

              </Grid>
              <Grid onClick={handleAddClassPromotion} item lg={12} md={12} sm={12} xs={12}
                className={`${classes.add} flex align-items-center`}
              >
                <Icon icon="gridicons:add-outline" />
                <p>Add Another Class Mapping</p>
              </Grid>
            </Grid>
          }
          modalFooter={
            <>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Save Settings"
                onClick={handleSavePromotions}
                isLoading={isSaving}
              />
            </>
          }
          isopen={modalOpen}
          closeModal={handleModalOpen}
        />
      </div>
    </Layout>
  );
};

export default Promotion;
